import { shape, string } from 'prop-types'
import { type FC } from 'react'
import { connectStateResults } from 'react-instantsearch-dom'
import { compose } from 'redux'

import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import { withI18n } from 'shared/utils/withI18n'
import { Hits } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Hits'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { i18nType, publicRuntimeConfigType } from 'views/utils/propTypes'
import { searchResultsType } from 'views/utils/propTypes/hits'

const RegularHits: FC<ComponentProps> = ({ searchResults, ...rest }) => {
  if (!searchResults) {
    return null
  }

  const {
    hits,
    page: currentPage,
    hitsPerPage,
    queryID,
    index: indexName,
  } = searchResults

  return (
    <Hits
      {...{ hits, indexName, currentPage, hitsPerPage, queryID, ...rest }}
    />
  )
}

const RegularHitsPropTypes = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  i18n: i18nType,
  searchResults: shape(searchResultsType).isRequired,
  query: string,
}

const RegularHitsDefaultProps = {
  query: '',
}

type ComponentProps = InferPropsWithDefaults<
  typeof RegularHitsPropTypes,
  typeof RegularHitsDefaultProps
>

export default compose(
  connectStateResults,
  withI18n(),
  withShopAndRuntimeConfig
)(RegularHits)
